import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.promise.js';
import { __decorate, __param, __metadata, __awaiter } from '../../_virtual/_tslib.js';
import { HttpClient } from '@hub-la/fe-core-http-client';
import merge from 'deepmerge';
import { inject } from 'inversify';
import { isNil } from 'lodash';
import { AssetStatus } from '../domain/dtos/asset-status.js';
import '../domain/dtos/asset-subtype.js';
import { AssetType } from '../domain/dtos/asset-type.js';
import '../domain/dtos/query-key.js';
import '../domain/dtos/upload-status.js';
import { GetAsset } from './get-asset.js';
import { waitFor } from './wait-for.js';

let GetVideoThumbnail = class GetVideoThumbnail {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  execute(data) {
    // When the thumbnail is not loaded yet, it has a string "playbackId" on it, so we need to wait until the webhook updates it with the correct id.
    const hasThumb = url => /^(.*?(\bplaybackId\b)[^$]*)$/.test(url) ? false : true;
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(resolve => __awaiter(this, void 0, void 0, function* () {
      var _a;
      let isThumbLoaded = hasThumb(data.url);
      if (!isThumbLoaded) {
        do {
          yield waitFor(2000); // 2 sec
          const asset = yield new GetAsset(this.httpClient).execute(data.id);
          if (isNil(asset.url)) {
            return;
          }
          if (hasThumb(asset.url)) {
            isThumbLoaded = true;
            resolve(merge(data, {
              type: AssetType.video,
              status: AssetStatus.available,
              metadata: {
                thumbnailUrl: (_a = asset.metadata) === null || _a === void 0 ? void 0 : _a.thumbnailUrl
              }
            }));
          }
        } while (!isThumbLoaded);
      }
      data.type = AssetType.video;
      resolve(data);
    }));
  }
};
GetVideoThumbnail = __decorate([__param(0, inject(HttpClient)), __metadata("design:paramtypes", [HttpClient])], GetVideoThumbnail);

export { GetVideoThumbnail };
